import { type FC } from 'react';

import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';
import { useListingByPinContext } from '@/microfrontends/listing/shared/context/ListingByPinContext';

import { SortListingByPinButtonContainer } from '../SortListingButtonContainer';

import { HeaderSEOBlock } from './components/HeaderSEOBlock';

export const HeaderSEOBlockByPinContainer: FC = () => {
  const {
    listingProperties: { aggregatedOffersCount: totalOffers },
  } = useListingByPinContext();
  const { config } = useListingAppContext();

  /**
   * @todo Удалить RSку
   * @description Данный функционал появился в задаче CD-184633, будет удалён в задаче CD-185006
   */
  const listingByPinSortingEnabled = config.getStrict<boolean>('search-frontend.ListingByPinSorting.Enabled');

  return (
    <HeaderSEOBlock
      offersCount={totalOffers}
      sortButton={totalOffers > 1 && listingByPinSortingEnabled ? <SortListingByPinButtonContainer /> : null}
      title={null}
    />
  );
};
